import { render } from "./List_PreOrder.vue?vue&type=template&id=0511a961"
import script from "./List_PreOrder.vue?vue&type=script&lang=js"
export * from "./List_PreOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__